import script from "./responsitiveData.vue?vue&type=script&lang=js"
export * from "./responsitiveData.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__